import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/client";
import "./Auth.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const googleDone = useRef(false);

  useEffect(() => { if (user) navigate("/"); }, [user, navigate]);

  useEffect(() => {
    const id = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!id || document.getElementById("gsi-script")) return;

    const script = document.createElement("script");
    script.id = "gsi-script";
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => {
      if (!window.google) return;
      window.google.accounts.id.initialize({
        client_id: id,
        auto_select: false,
        cancel_on_tap_outside: true,
        callback: (response) => {
          if (googleDone.current) return;
          googleDone.current = true;
          api.post("/user/google-login", { credential: response.credential })
            .then(({ data }) => {
              localStorage.setItem("token", data.token);
              localStorage.setItem("user", JSON.stringify(data.user));
              window.location.href = "/";
            })
            .catch(() => {
              googleDone.current = false;
              setError("Google login failed. Try again.");
            });
        },
      });
      const el = document.getElementById("google-btn");
      if (el) {
        window.google.accounts.id.renderButton(el, {
          theme: "filled_black", size: "large", width: 380, shape: "pill", text: "signin_with",
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  function handleSubmit() {
    if (!email || !password || busy) return;
    setBusy(true); setError(null);
    api.post("/user/login", { email, password })
      .then(({ data }) => {
        login(data.token, data.user);
        navigate("/");
      })
      .catch((err) => {
        setError(err.message || "Login failed.");
      })
      .finally(() => setBusy(false));
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") handleSubmit();
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-left">
        <div className="auth-left-content">
          <h1>ONE ACCOUNT FOR ALL<br />RINSTORE SERVICES</h1>
          <p>Hi there! Sign up an account and enjoy your shopping experience on RinStore.</p>
          <Link to="/register" className="auth-outline-btn">CREATE NEW ACCOUNT</Link>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h2>SIGN IN</h2>

          <input className="auth-input" type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} onKeyDown={handleKeyDown} />
          <input className="auth-input" type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDown} />

          {error && <p className="auth-error">{error}</p>}

          <button className="auth-btn" type="button" onClick={handleSubmit} disabled={busy}>
            {busy ? "Signing in…" : "Sign In"}
          </button>

          <Link to="/forgot-password" className="auth-link">Forgot password?</Link>

          <div className="auth-divider"><span>or sign in with</span></div>

          <div id="google-btn" className="google-btn-wrap"></div>

          <p className="auth-footer-text">
            By signing in, you agree to our <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms of Service</Link>
          </p>
        </div>
      </div>
    </div>
  );
}